module.exports = __webpack_public_path__ + "img/gallery-img-1.50e7173c.jpg";